import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../../models/report.model';
import { LovValues } from '../../../../../models/template.model';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../../../utils/dynamic-data-retrievers';
import { currencyLov, PropertyType, valueWithUomPrefix } from '../../us/us.common';

export const displayFnMap = {
  478: {
    // 478 - status
    // clear
    displayFn: (record: ReportRecord, _, status) => {
      return status.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, status, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '';
        })
      );
    },
  },
  479: {
    // 479 - year built
    // clear
    displayFn: (record: ReportRecord, options, yearBuilt) => {
      const value = displayFnWrapper(record, options, yearBuilt);
      return Array.isArray(value) ? value.join(', ') : value;
    },
  },
  480: {
    // 480 - Class
    // clear
    displayFn: (record: ReportRecord, _, classArg) => {
      return classArg.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, classArg, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '-';
        })
      );
    },
  },
  524: {
    // 524 - date available
    // clear
    displayFn: displayFnWrapper,
  },
  481: {
    // 481 - Average Direct Asking Rate Yearly
    // clear
    displayFn: (record: ReportRecord, options, askingRateYearly) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, askingRateYearly, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  483: {
    // 483 - Service Charge
    // clear
    displayFn: (record: ReportRecord, options, serviceCharge) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, serviceCharge, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  476: {
    // 476 - description
    // TODO: BE needs to support colloquial and not colloquial (currently only sending colloquial)
    displayFn: displayFnWrapper,
  },
  523: {
    // 523 - location transport
    // clear
    displayFn: displayFnWrapper,
  },
  491: {
    // 491 - Floor Label
    // clear
    displayFn: displayFnWrapper,
  },
  492: {
    // 492 - Usage Label
    // clear
    displayFn: displayFnWrapper,
  },
  493: {
    // 493 - Sqm label
    // clear
    displayFn: displayFnWrapper,
  },
  494: {
    // 494 - Available Label
    // clear
    displayFn: displayFnWrapper,
  },
  485: {
    // 485 - Parking Space
    // clear
    displayFn: displayFnWrapper,
  },
};
